import React from 'react';

const ComponentHeader = ({ name }) => {
  return <label className="quicksand-700-text font-32 mb-6">{name}</label>;
};

export default ComponentHeader;
